import React from 'react'
import { AppBar, Toolbar, IconButton, Badge} from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { FcHome } from 'react-icons/fc'
import useStyles from './style';
// import Logo from '../Logo';

const MySmallNavBar = ({ totalProducts }) => {
    const classes = useStyles();
    // const location = useLocation();
    
    return (
        <AppBar position='fixed' className={classes.appBar} >
            <Toolbar className={classes.Toolbar}>
                <IconButton component={Link} to="/" aria-label="Home" color="inherit">
                    <FcHome />
                </IconButton>

                <IconButton component={Link} to="/cart" aria-label="Cart Items" color="inherit">
                    <Badge badgeContent={totalProducts} color="secondary">
                        <ShoppingCart />
                    </Badge>
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}

export default MySmallNavBar

